<template>
  <div class="navbar">
    <div :class="['login', { open: isOpened }]">
      <div>Connexion/Inscription</div>
      <div class="input">
        <label for="connexion">Nom d'utilisateur</label>
        <input type="text" name="connexion" v-model="formData.username">
      </div>
      <div class="input">
        <label for="password">Mot de passe</label>
        <input type="password" name="password" v-model="formData.mdp">
        <p>Pas encore inscris ? <router-link :to="'/Register'"><u>Créer un compte</u></router-link></p>
      </div>
      <div>
        <p class="error" v-if="formErrors.value === true">{{ formErrors.message }}</p>
        <button class="button up2" @click="handleLogin">Se connecter</button>
      </div>
    </div>
  
    <div v-if="isMenuOpen" class="user-menu">
      <ul>
        <li><router-link to="/profil" class="no-decoration">
            <Icon icon="solar:user-circle-bold" width="24" height="24" style="color: #fff" /> Accès profil
          </router-link>
        </li>
        <li><router-link to="/" class="no-decoration">
            <Icon icon="material-symbols:settings-outline" width="24" height="24" style="color: #fff" /> Paramètres
          </router-link>
        </li>
        <li v-if="isAdmin">
          <router-link to="/admin" class="no-decoration">Administration</router-link>
        </li>
        <li @click="logout">
          <a href="#" class="no-decoration">
            <Icon icon="solar:logout-2-outline" width="24" height="24" style="color: #fff" /> Déconnexion
          </a>
        </li>
      </ul>
    </div>
  
    <div class="nav-container">
      <button @click="toggleMenu" class="up">MENU</button>
  
      <h2>
        <router-link :to="'/'">
          <span class="textBlue">M</span><span class="textGradiant">&</span><span class="textYellow">S</span>
        </router-link>
      </h2>
      <div class="button-container">
        <button v-if="!isLoggedIn" class="button up" @click="handleLoginClick">
          LOGIN
        </button>
        <div class="button-container" v-if="isLoggedIn">
          <p class="p-button"><span> {{ username }}</span></p>
          <img src="https://cdn-icons-png.flaticon.com/512/6596/6596121.png" width="36px" alt="" class="img" @click="toggleUserMenu">
        </div>
      </div>
    </div>
  
    <div :class="['burgerMenu', { open: isOpen, hidden: scrollY > 0 }]">
      <div>
        <h3 class="textYellow">SECTION</h3>
        <div v-for="(item, index) in items" :key="index" class="menu-item" @click="toggleOpen(index)">
          <p class="textWhite" @click="toggleHover(index, true)">
            {{ item.title }}
          </p>
          <div class="list">
            <ul :class="{ visible: openStates[index] }">
              <li v-for="(subItem, subIndex) in item.subItems" :key="subIndex">
                <template v-if="subItem.external">
                  <!-- Utiliser une balise <a> pour les liens externes -->
                  <a :href="subItem.link" class="sub-item-link" target="_blank" rel="noopener noreferrer">
                    {{ subItem.title }}
                  </a>
                </template>
                <template v-else>
                  <!-- Utiliser un <router-link> pour les liens internes -->
                  <router-link :to="subItem.link" class="sub-item-link">
                    {{ subItem.title }}
                  </router-link>
                </template>
              </li>
            </ul>
          </div>
        </div>
  
        <h3 class="textYellow mt-20">SOCIALS</h3>
        <div style="margin-bottom: 30px;">
          <p class="textWhite">Macker prod</p>
          <div style="display: flex; gap: 20px">
              <a style="display: flex; align-items: center; gap: 10px;"
                href="https://www.youtube.com/@MackerPROD" target="_blank">
                <Icon icon="logos:youtube-icon"
                width="22" height="16" style="color: white" />
              </a>
              <a style="display: flex; align-items: center; gap: 10px;"
                href="https://www.linkedin.com/in/mickael-descheemacker-986463166/" target="_blank">
                
                <Icon icon="devicon:linkedin"
                width="20" height="20" style="color: white" />
              </a>
              <a style="display: flex; align-items: center; gap: 10px;"
                href="https://www.facebook.com/Mackerprod/" target="_blank">
                 
                <Icon icon="logos:facebook"
                width="20" height="20" style="color: white" />
              </a>
          </div>
        </div>
        <div>
          <p class="textWhite">Studee Photographie</p>
          <div style="display: flex; gap: 20px">
              <a style="display: flex; align-items: center; gap: 10px;"
                href="https://www.facebook.com/delphine.carlier.7543" target="_blank">
                <Icon icon="logos:facebook"
                width="20" height="20" style="color: white" />
              </a>
          </div>
        </div>
      </div>
  
      <div class="cgu">
        <a href="#/mentions"><p>Mentions Légales</p></a>
        <p>
          <span class="ffsystem">©</span>
          <span class="ffsystem">2</span>
          <span class="ffsystem">0</span>
          <span class="ffsystem">2</span>
          <span class="ffsystem">3</span>
          <span class="ffsystem">-</span>
          <span class="ffsystem">2</span>
          <span class="ffsystem">0</span>
          <span class="ffsystem">2</span>
          <span class="ffsystem">4</span>
          M&S Agency
        </p>
        <a href="#/cgu"><p>Conditions d'utilisation</p></a>
      </div>
    </div>
  </div>
</template>

  
  <script setup>
  import { ref, onMounted, onBeforeUnmount, computed } from 'vue';
  import { Icon } from '@iconify/vue';
  import { useRouter } from 'vue-router';
  import { useStore } from 'vuex';

  const store = useStore();
  const isOpen = ref(false);
  const isOpened = ref(false);
  const scrollY = ref(0);
  const router = useRouter();
  const isLoading = ref(false);
  const isMenuOpen = ref(false);

  const  toggleUserMenu = () => {
    isMenuOpen.value = !isMenuOpen.value
  }

  // Vérifier si l'utilisateur est connecté via un getter
  const isLoggedIn = computed(() => store.getters.isLoggedIn);
  const isAdmin = computed(() => store.getters.isAdmin);
  
  
  const username = localStorage.getItem('username');
  // Données du formulaire
  const formData = ref({
    username: '',
    mdp: '',
  });

    // Objets contenant les messages d'erreurs
    const formErrors = ref({
      value: false,
      message: ''
  });

  const items = ref([
    {
      title: 'MACKER PROD Video Création',
      link: '/',
      subItems: [
        { title: 'À propos', link: '/mackerprod' },
        { title: 'Prestations', link: '/mackerprod/#Prestations' },
        { title: 'Réalisations', link: '/mackerprod/#Realisation' },
        { title: 'Contact', link: '/mackerprod/#Contact' },
        { title: 'Devis', link: '/devis/' },
      ],
    },
    {
      title: "STU'DEE Photographie",
      link: '/studee',
      subItems: [
        { title: 'À propos', link: '/studee/#About' },
        { title: 'Prestations', link: '/studee/#Prestations' },
        { title: 'Galerie', link: '/studee/#Galerie' },
        { title: 'Contact', link: '/studee/#Contact' },
        { title: 'Devis', link: '/devis' },
      ],
    },
    {
      title: 'Formule DUO',
      link: '/duo',
      subItems: [
        { title: 'À propos', link: '/duo' },
        { title: 'Matériel', link: '/materiel' },
        { title: 'Devis (guide)', link: '/duo/#devis' },
        // { title: 'Calendrier', link: '/duo/calendrier' },
        {
        title: 'Mariages.net',
        link: 'https://www.mariages.net/video-mariage/macker-prod--e366435',
        external: true, // Ajouter un flag pour les liens externes
        }
      ],
    },
    {
      title: isLoggedIn.value ? 'Accéder au compte' : "S'inscrire",
      link: isLoggedIn.value ? '/Account' : '/Register',
      subItems: [
        { title: isLoggedIn.value ? 'Mon profil' : "Créer un compte", link: isLoggedIn.value ? '/profil' : '/Register' },
      ],
    },
  ]);
  
  // États d'ouverture des sous-menus
const openStates = ref(new Array(items.value.length).fill(false));

// Fonction pour ouvrir/fermer le sous-menu au clic
const toggleOpen = (index) => {
  openStates.value = openStates.value.map((state, i) => i === index ? !state : false);
};

  const hoverStates = ref(new Array(items.value.length).fill(false));
  
  const toggleMenu = () => {
    isOpen.value = !isOpen.value;
  };
  
  const toggleLogin = () => {
    isOpened.value = !isOpened.value;
  };
  
  const toggleHover = (index, hovering) => {
    hoverStates.value[index] = hovering;
  };
  
  const handleScroll = () => {
    scrollY.value = window.scrollY;
    isOpen.value = false;
    isOpened.value = false;
  };
  
  onMounted(() => {
    window.addEventListener('scroll', handleScroll);
  });
  
  onBeforeUnmount(() => {
    window.removeEventListener('scroll', handleScroll);
  });

  // Gestion du bouton LOGIN / MON COMPTE
const handleLoginClick = () => {
  if (isLoggedIn.value) {
    router.push('/'); // Redirige vers la page du compte
  } else {
    toggleLogin(); // Ouvre la fenêtre de connexion
  }
}

const handleLogin = async () => {
  formErrors.value.general = ''; // Réinitialiser les erreurs générales
  isLoading.value = true; // Afficher le loader

  // const apiUrl = 'http://51.83.71.158:3001'
  const apiUrl = process.env.NODE_ENV === 'production' ? 'https://www.mackerprod.com' : 'http://localhost:3001';
  try {
    const response = await fetch(`${apiUrl}/api/users/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData.value),
    });

    const result = await response.json();

    if (!response.ok) {

      // if (result.message.includes("username")) {
      //   formErrors.value.username = result.message;
      // } else if (result.message.includes("email")) {
      //   formErrors.value.email = result.message;
      // } else if (result.message.includes("mot de passe")) {
      //   formErrors.value.mdp = result.message;
      // } else {
      //   formErrors.value.general = result.message || 'Une erreur est survenue.';
      // }

      formErrors.value.value = true;
      formErrors.value.message = result.message;

    } else {
      console.log('Connexion réussie:', result);
      formErrors.value.message = "Connexion réussie !";
      
      //  Appeler l'action Vuex pour se connecter
      store.dispatch('login', result.token);

      router.push('/profil');
    }
  } catch (error) {
    console.error('Erreur lors de la soumission:', error);
    formErrors.value.general = "Erreur lors de la connexion. Veuillez réessayer.";
  } finally {
    isLoading.value = false; // Cacher le loader
  }
};



// Déconnexion de l'utilisateur
const logout = () => {
  store.dispatch('logout');
  isMenuOpen.value = false;  
  router.push('/');      
};

</script>

<style lang="scss" scoped>
@import '../assets/main.css';

.navbar {
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    /*background-color: var(--bgBlack);*/
    z-index: 2300;


    .nav-container {
        position: relative;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        font-family: var(--Cormorant);
        letter-spacing: -0.3rem;
        font-weight: 100;
        font-size: 40px;
        line-height: 2;
        padding: 20px;
        color: var(--textWhite);
        box-shadow: var(--boxShadow);
        height: 80px;
    }
    .button-container {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 15px;
      font-weight: 400;

      .button-container p {
        margin: 0;
        color: var(--textBlack);
        font-family: 'Roboto';
        font-size: 14px;
        letter-spacing: 0;
        text-transform: none;
      }

    }
    button {
        font-size: 14px;
        border-radius: 26px;
        padding: 8px 16px;
        cursor: pointer;
        font-family: 'Roboto', sans-serif;
        color: var(--textWhite);
    }

    .burgerMenu {
       /* background: linear-gradient(90deg, rgba(26,32,38,1) 0%, rgba(63,31,39,1) 100%);*/
       background: radial-gradient(circle at bottom right, rgba(26,32,38,1)30%, rgba(0,0,0,1) 90%);
        position: absolute;
        z-index: 900;
        top: 100%;
        left: -100%;
        height: 100vh;
        transition: left 0.3s ease;
        padding: 20px;
        box-shadow: var(--boxShadow);
        font-family: 'Roboto';
      } 
    .burgerMenu.open {
        left: -0;
      }
    .burgerMenu.hidden {
      visibility: hidden;
      opacity: 0;
      left: -100%;
      }
    .user-menu {
      position: absolute;
      top: 120%;
      z-index: 0;
      right: 1%;
      width: auto;
      background: red;
      height: auto;
      padding: 20px 30px;
      color: var(--textWhite);
      background: rgba(26,32,38,1);
      font-family: 'Roboto', sans-serif;
      box-shadow: var(--boxShadow);
      border-radius: 5px;

      .user-menu ul li{
        margin-bottom: 5px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: space-evenly;
      }
      .user-menu ul li router-link{
        text-decoration: none;
        color: var(--textWhite);
      }
      .no-decoration {
        text-decoration: none;
        color: var(--textWhite);
        display: flex;
        gap: 8px;
        align-items: center;

      }
    }
    .img {
      cursor: pointer;
    }

    .user-menu ul {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      gap: 15px;
    }
    
}
h3 {
    margin-bottom: 40px;
    font-family: var(--Aquawax);
    font-weight: bold;
}

p {
    margin-bottom: 20px;
    cursor: pointer;
    font-family: 'Roboto';
    font-size: 18px;
    /* text-transform: uppercase; */
    transition: transform 0.3s ease; /* Ajout de la transition pour un effet fluide */
}

/*p:hover {
  transform: scale(1.02) translateX(2px);
}*/

.list ul {
    opacity: 0;
    max-height: 0;
    overflow: hidden;
    transition: opacity 0s ease, max-height 0.6s ease;

}

.list ul.visible {
    opacity: 1;
    max-height: 200px;
    margin-bottom: 26px;
    transform: translateX(30px);
}

.list ul.visible li {
    margin-bottom: 10px;
    color: var(--textYellow);
    cursor: pointer;
}

.menu-item {
    position: relative;
    display: block;
    font-family: 'Roboto';
}

.icon{
    transform: rotate(45deg);
}

p:hover .icon {
    transform: rotate(235deg);
}


.cgu {
    position: absolute;
    bottom: 7%;
    left: 50%;
    transform: translate(-50%);
    padding: 20px 20px 20px 20px;
    margin-top: 5rem;
    display: flex;
    gap: 30px;
    flex-direction: row;
    justify-content: space-between;
    font-family: var(--Aquawax);
    color: var(--textWhite);
    width: 100%;
    border-top: 1px solid rgba($color: #fff, $alpha: 0.10);
}

.cgu p {
    font-size: 10px;
    text-transform: none;
}

@media(min-width: 1025px) {
    .burgerMenu {
        width: 25%;
    }

}
@media (min-width: 200px) and (max-width: 1024px) {
    .burgerMenu {
        width: 100%;
    }
    .cgu {
        bottom: 6.5%;
    }
}

.router-link-exact-active, 
.router-link,
.sub-item-link {
  color: var(--textWhite);
  text-decoration: none; 
}

.router-link-active {
    color:  var(--textYellow);
    text-decoration: underline;
}

h2 .router-link-active,.router-link-exact-active, 
.router-link,
.sub-item-link {
    text-decoration: none;
}

.up {
    color: var(--textBlack);
    --hover: #fff;
    background: var(--textYellow);
    border: none;
    font-family: 'Roboto', sans-serif;
    padding: 8px 16px;
    transition: 0.25s;
  }
  
  .up:hover,
  .up:focus {
    box-shadow: inset 0 -3.25em 0 0 var(--bgBlue);
    color: var(--textWhite);
  }

  .up2 {
    color: var(--textWhite);
    --hover: #fff;
    background: var(--textYellow);
    border: none;
    font-family: 'Roboto', sans-serif;
    padding: 8px 16px;
    transition: 0.25s;
  }
  .up2:hover,
  .up2:focus {
    box-shadow: inset 0 -3.25em 0 0 var(--bgWhite);
    color: #000;
  }

  .error {
    font-size: 14px;
    color: red;
  }

  .login {
    display: none;
    position: absolute;
    top: 120%;
    z-index: 0;
    right: 2%;
    width: 300px;
    background: red;
    height: auto;
    text-align: center;
    padding: 20px 20px 0 20px;
    color: var(--textWhite);
    background: rgba(26,32,38,1);
    font-family: 'Roboto', sans-serif;
    box-shadow: var(--boxShadow);
    border-radius: 5px;
    transition: opacity 0.5s ease;
  }

  .login.open {
    display: block;
    opacity: 1;
    transition: opacity 0.5s ease;

  }

  .login div {
    margin-bottom: 20px;
  }

  .input {
    display: flex;
    flex-direction: column;
  }
  .input label {
    text-align: left;
    font-size: 12px;
    margin-bottom: 5PX;
  }

  .input p {
    text-align: left;
    font-size: 12px;
    text-transform: none;
    margin: 0;
    font-family: 'Roboto',sans-serif;
  }

  u {
    text-decoration: none;
    color: var(--textYellow);
  }

  @media (max-width: 1025px) {
    .p-button {
      display: none;
    }
  }
</style>
